import { render, staticRenderFns } from "./attachment.vue?vue&type=template&id=5ef86d8b"
import script from "./attachment.vue?vue&type=script&lang=js"
export * from "./attachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports